import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { IGenericServiceResponse } from '../interfaces/IServiceResponse';
import { ISelfReportDetailed } from '../interfaces/SelfReport/ISelfReportDetailed';
import { environment } from 'src/environments/environment';
import { PatientService } from './patient.service';
import { SwalToastService } from './swal.service';

@Injectable({ providedIn: 'root' })
export class SelfReportService {
  public selfReportDataSub = new BehaviorSubject<ISelfReportDetailed[]>([]);

  public selfReportLoadingSub = new BehaviorSubject<boolean>(false);

  constructor(
    private readonly _http: HttpClient,
    private readonly patientService: PatientService,
    private readonly swalToastService: SwalToastService
  ) {}

  async getData() {
    this.selfReportLoadingSub.next(true);
    this.getSelfReport(this.patientService.patientIDsignal()).subscribe({
      next: (response) => {
        this.selfReportDataSub.next(response?.data!);
        this.selfReportLoadingSub.next(false);
      },
      error: (err) => {
        this.selfReportDataSub.next([]);
        this.selfReportLoadingSub.next(false);
        this.swalToastService.toastError('Unable to retrieve self reports');
      },
    });
  }

  getSelfReport(
    patientId: string
  ): Observable<IGenericServiceResponse<ISelfReportDetailed[]>> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this._http.get<IGenericServiceResponse<ISelfReportDetailed[]>>(
      `${environment.BACKEND_URL}SelfReport/${patientId}`,
      {
        headers: headers,
      }
    );
  }
}
